import { Button } from '@material-ui/core';
import React, { ReactNode } from 'react';
import clsx from 'clsx';
import { TimesIcon } from '../../../icon/solid';
import useStyles from './styles';
import { ButtonTypes, ButtonConfig } from './types';


type Props = {
  onClick: () => void;
  type?: ButtonTypes;
  title?: string | ReactNode;
  disabled?: boolean;
};


const DialogButton = ({
  onClick,
  type = 'submit',
  title,
  disabled,
}: Props) => {
  const classes = useStyles();

  const getButtonConfig = (buttonType: ButtonTypes): ButtonConfig => {
    if (buttonType === 'cancel') {
      return {
        title: (
          <>
            <TimesIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>Cancel</span>
          </>
        ),
        classes: clsx(classes.cancelButton, classes.panelButton),
        color: 'default',
        variant: 'contained',
      };
    }

    if (buttonType === 'submit') {
      return {
        title: (
          <>
            <TimesIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>Save</span>
          </>
        ),
        classes: clsx(classes.panelButton),
        color: 'primary',
        variant: 'contained',
      };
    }

    if (buttonType === 'additional') {
      return {
        title: (
          <>
            <TimesIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>Change</span>
          </>
        ),
        classes: clsx(classes.panelButton),
        color: 'primary',
        variant: 'text',
      };
    }

    return {
      title: 'title',
      classes: '',
      color: 'default',
      variant: 'contained',
    };
  };

  const btnConfig = getButtonConfig(type);

  return (
    <Button
      className={btnConfig.classes}
      onClick={onClick}
      variant={btnConfig.variant}
      color={btnConfig.color}
      disabled={disabled}
    >
      {
        title
          ? <span className={classes.buttonText}>{title}</span>
          : btnConfig.title
      }
    </Button>
  );
};

export default DialogButton;
